<app-loader *ngIf="isDisabled"></app-loader>
<div class="card mt-2 border-radius-0 p-1">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Advance Expense
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn btn-outline-primary btn-sm mx-1" (click)="addTrip()"
                    [disabled]="isDisabled"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Add Trip':'Loading...'}}</button>

                <button type="button" class="btn btn btn-outline-primary btn-sm mx-1" (click)="addAdvanceExpenses()"
                    [disabled]="isDisabled"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Request Advance':'Loading...'}}</button>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row">
                <div class="col-md-3">
                    <label for="Type" class="form-font-label">Type</label>
                    <select class="form-select" aria-label="Type" placeholder="Type" title="Type" name="Type"
                        [(ngModel)]="Filter.ApprovalStatus" #CompanyMasterId="ngModel" (change)="ClearData()" required>
                        <option disabled [value]=null>--Select Type--</option>
                        <option value="All">All</option>
                        <option value="Pending">Pending</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Corrected">Corrected</option>
                    </select>
                </div>
                <div class="col-md-3" *ngIf="Filter.ApprovalStatus != 'Pending'">
                    <label for="FromDateObj" class="form-font-label">From
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" readonly
                            (ngModelChange)="ClearData()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3" *ngIf="Filter.ApprovalStatus != 'Pending'">
                    <label for="ToDateObj" class="form-font-label">To
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" readonly
                            (ngModelChange)="ClearData()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-md-auto align-self-end">
                    <button class="btn btn-primary" type="submit" [disabled]="isDisabled"><i
                            class="bi bi-cloud-download me-2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}</button>
                </div>
            </div>
        </form>
        <div class="mt-2">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <!-- <th style="width: 5px;"><input class="form-check-input" type="checkbox" id="IsCheck" (change)="CheckAll($event)" name="IsCheck">
                    </th> -->
                        <th>View</th>
                        <th>TripName</th>
                        <th>FromDate</th>
                        <th>ToDate</th>
                        <th>Description</th>
                        <th>AdvanceAmount</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <!-- <td style="width: 5px;" class="text-center">
                        <div style="width: 5px;"><input class="form-check-input" type="checkbox" id="IsCheck{{i}}"
                                name="IsCheck{{i}}" [(ngModel)]="TableData['IsCheck']">
                        </div>
                    </td> -->
                        <td style="width: 5px;">
                            <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    [routerLink]="['/request/advanceexpense/detail/',TableData['ESS_ExpenseAdvanceRequestId']]"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 120px;">
                            <div style="width: 120px;">{{TableData['TripName']}}</div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['FromDate']}}</div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['ToDate']}}</div>
                        </td>
                        <td style="width: 200px;">
                            <div style="width: 200px;">{{TableData['Description']}}</div>
                        </td>
                        <td style="width: 120px;text-align:end">
                            <div>{{TableData['AdvanceAmount']}}</div>
                        </td>
                        <td style="width: 80px;"><span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>